import { CancelButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { SimpleTable, TableActions } from '@core/components/Table';
import { TableActionButton, TableActionButtonDelete, TableActionContainer } from '@core/components/TableAction';
import { useApiUtils } from '@core/util/apiUtils';
import { Grid } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import { SelectBanco, SelectCategoria } from 'app/components/Select';
import { confirmarAlert } from 'app/services/alerts';
import { regraAutomaticaApi } from 'app/services/api/regraAutomaticaApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { eventReactGA } from 'app/utils/analyticsUtil';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ConciliacaoContext } from '../ConciliacaoContext';
import { ConciliacaoModal } from '../modal/ConciliacaoModal';

const RegraAutomaticaModal = () => {
  const [modal, setModal] = useContext(ConciliacaoContext).modal;
  const [, setRegrasAutomatica] = useContext(ConciliacaoContext).regraAutomatica;
  const [regrasAutomaticas, setRegrasAutomaticas] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [, setPage] = useState(0);
  const [, setSize] = useState(15);
  const [, setSort] = useState('banco.nome,DESC');
  const [loading, setLoading] = useContext(GlobalContext).loading;

  const CONCILIACAO = 'Conciliação';

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  useEffect(() => {
    if (modal === ConciliacaoModal.regrasAutomaticas) fetchData();
    // A função é recriada a cada render; incluí-la reexecutaria a busca em loop.
    // O efeito depende apenas do gatilho listado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal]);

  const initialValues = {
    lancamento: 'TODAS',
    palavraChave: '',
    categoria: undefined,
    banco: undefined,
    page: 0,
    q: '',
    size: 15,
    sort: 'banco.nome,ASC',
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: () => {},
    validateOnChange: true,
    validateOnBlur: true,
  });

  useEffect(() => {
    fetchData();
    // A função é recriada a cada render; incluí-la reexecutaria a busca em loop.
    // O efeito depende apenas do gatilho listado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values]);

  const close = () => {
    formik.resetForm();
    setModal('');
  };

  const fetchData = async (search = initialValues) => {
    setLoading(true);
    try {
      search.lancamento = formik.values.lancamento;
      search.palavraChave = formik.values.palavraChave;
      search.categoriaId = formik.values.categoria?.id;
      search.bancoId = formik.values.banco?.id;

      const response = await regraAutomaticaApi().buscarTodos(search);

      setPage(response.data.number);
      setSize(response.data.size);
      setTotalElements(response.data.totalElements);
      setRegrasAutomaticas(response.data.content);
    } catch (err) {
      apiUtils.handleApiError(err);
    }
    setLoading(false);
  };

  const handlerEditar = async (regra) => {
    setLoading(true);

    eventReactGA(CONCILIACAO, 'Atualizar regra automática');
    const response = await regraAutomaticaApi().buscar(regra.id);
    if (response.data) {
      setRegrasAutomatica(response.data);
      setModal(ConciliacaoModal.cadastrarRegrasAutomaticas);
    }
    setLoading(false);
  };

  const handlerExcluir = (regra) => {
    let title = 'Você realmente deseja excluir?';
    confirmarAlert({
      opcoes: {
        title,
      },
      confirmar: async () => {
        setLoading(true);
        try {
          eventReactGA(CONCILIACAO, 'Excluir regra automática');
          const response = await regraAutomaticaApi().excluir(regra.id);
          if (response?.status === 204) {
            showSuccess('Regra Automática excluída com sucesso.');
            setLoading(false);
            fetchData();
          }
        } catch (err) {
          apiUtils.handleApiError(err);
        }
      },
    });
  };

  const handlerCadastrar = () => {
    setRegrasAutomatica({});
    setModal(ConciliacaoModal.cadastrarRegrasAutomaticas);
  };

  const columns = [
    {
      name: 'palavraChave',
      title: 'Palavra-chave',
      align: 'left',
      getCellValue: (regra) => regra?.palavraChave,
      sortingEnabled: false,
    },
    {
      name: 'categoria.nome',
      title: 'Categoria',
      align: 'left',
      getCellValue: (regra) => (regra?.categoria?.id ? regra?.categoria?.indice + ' ' + regra?.categoria?.nome : '-'),
      sortingEnabled: true,
    },
    {
      name: 'banco.nome',
      title: 'Banco',
      align: 'left',
      getCellValue: (regra) => regra?.banco?.nome,
      sortingEnabled: true,
    },
    {
      name: 'lancamento',
      title: 'Lançamento',
      align: 'left',
      getCellValue: (regra) => {
        if (regra?.lancamento === 'MOVIMENTACAO_BANCARIA') return 'Movimentação bancária';
        if (regra?.lancamento === 'TRANSFERENCIA') return 'Transferência';
      },
      sortingEnabled: true,
    },
    {
      name: '',
      title: '',
      sortingEnabled: false,
      align: 'left',
      width: 125,
      getCellValue: (regra) => {
        return (
          <TableActionContainer>
            <TableActionButton
              title="Editar"
              icon={<Edit size={10} style={{ fontSize: '0.5em' }} />}
              onClick={() => handlerEditar(regra)}
            />
            <TableActionButtonDelete size={12} onClick={() => handlerExcluir(regra)} />
          </TableActionContainer>
        );
      },
    },
  ];

  const actions = [
    {
      icon: <AddIcon />,
      name: 'cadastrar',
      tooltip: 'Cadastrar',
      show: true,
      onClick: handlerCadastrar,
    },
  ];

  return (
    <SimpleDialog fullScreen open={modal === ConciliacaoModal.regrasAutomaticas} onClose={close} innerScroll>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={(e) => {
            formik.handleSubmit();
          }}
          fullScreen
          header={{
            title: 'Regras automáticas',
            toolbar: (
              <>
                <CancelButton title="fechar" type="button" onClick={close}>
                  Fechar
                </CancelButton>
              </>
            ),
          }}
          content={
            <>
              <Grid container style={{ padding: 16 }} spacing={3}>
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                  <SelectInput
                    id="lancamento"
                    label="Lançamento"
                    onChange={formik.handleChange}
                    value={formik.values?.lancamento}
                    options={[
                      { id: 'MOVIMENTACAO_BANCARIA', title: 'Movimentação bancária' },
                      { id: 'TRANSFERENCIA', title: 'Transferência' },
                      { id: 'TODAS', title: 'Todas' },
                    ]}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                  <TextInput
                    id="palavraChave"
                    name="palavraChave"
                    label="Palavra-chave"
                    onChange={formik.handleChange}
                    value={formik.values?.palavraChave}
                    fullWidth
                    variant="outlined"
                    maxLength={50}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                  <SelectCategoria
                    id="categoria"
                    label="Categoria"
                    value={formik.values?.categoria}
                    onChange={formik.handleChange}
                    maxLength={100}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                  <SelectBanco
                    id="banco"
                    name="banco"
                    label="Banco"
                    onChange={formik.handleChange}
                    value={formik.values?.banco}
                  />
                </Grid>
              </Grid>
              <Grid container>
                <Grid item>
                  <SimpleTable
                    getRowId={(row) => row}
                    fetchOnCreate={false}
                    defaultSorting={[{ columnName: 'banco.nome', direction: 'asc' }]}
                    columns={columns}
                    hideSelection
                    rows={regrasAutomaticas}
                    loading={loading}
                    totalCount={totalElements}
                    fetchData={fetchData}
                    onCurrentPageChange={setPage}
                    onPageSizeChange={setSize}
                    onSortingChange={setSort}
                  />

                  <TableActions actions={actions} />
                </Grid>
              </Grid>
            </>
          }
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default RegraAutomaticaModal;
